import template from './reci-config-api-button.html.twig';

const {Component, Mixin, Application} = Shopware;

import deDE from '../snippet/de-DE.json';
import enGB from '../snippet/en-GB.json';

Component.register('reci-config-api-button', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
    ],

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB
    },

    data() {
        return {
            isLoading: false,
        };
    },

    computed: {
        customerRepository() {
            return this.repositoryFactory.create('customer');
        },
    },
    methods: {
        onClick: function (){
            const headers = this.customerRepository.buildHeaders();
            const initContainer = Application.getContainer('init');
            const httpClient = initContainer.httpClient;
            const data = {
                'clientId' : this.$attrs.actualConfigData["ReciPostAddressCheckerSw6.config.clientId"],
                'secretId' : this.$attrs.actualConfigData["ReciPostAddressCheckerSw6.config.secretId"],
                'currentSalesChannelId' : this.$attrs.currentSalesChannelId
            }

            this.isLoading = true;
            httpClient.post('/_action/reci/post/testAddressCheckApi', {data}, {headers}).then(({data}) => {
                if (data.success === false) {
                    this.createNotificationError({
                        message: data.msg,
                    });
                    throw data;
                }

                this.createNotificationSuccess({
                    message: this.$tc('reci-config.apiTest.successMsg'),
                });

                this.isLoading = false;
                return Promise.resolve();
            }).catch((errorResponse) => {
                this.isLoading = false;
            });
        }
    }
});
